/* Design selections stay within the product card that owns them. */
document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('.izwa-unstitched-edit .izwa-design-thumbnail');
  if (!thumbnail || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;

  const card = thumbnail.closest('.card-wrapper');
  const image = card?.querySelector('.card__media img');
  const variantId = thumbnail.dataset.variantId;
  if (!card || !image || !variantId) return;
  event.preventDefault();

  card.querySelectorAll('.izwa-design-thumbnail').forEach((item) => {
    const selected = item === thumbnail;
    item.classList.toggle('is-selected', selected);
    if (selected) item.setAttribute('aria-current', 'true');
    else item.removeAttribute('aria-current');
  });
  image.src = thumbnail.dataset.imageSrc;
  image.srcset = thumbnail.dataset.imageSrcset;
  image.alt = thumbnail.dataset.imageAlt;
  card.classList.add('izwa-variant-selected');

  card.querySelectorAll('.card__heading a, .card__media > a').forEach((link) => {
    link.href = thumbnail.href;
  });
  card.querySelectorAll('product-form input[name="id"]').forEach((input) => {
    input.value = variantId;
  });
  const available = thumbnail.dataset.available === 'true';
  card.querySelectorAll('product-form button[type="submit"]').forEach((button) => {
    button.disabled = !available;
    button.setAttribute('aria-disabled', String(!available));
    const label = button.querySelector('span:not(.sold-out-message)');
    if (label) label.textContent = available ? thumbnail.dataset.addLabel : thumbnail.dataset.soldoutLabel;
    button.querySelector('.sold-out-message')?.classList.add('hidden');
  });

  const onSale = Number(thumbnail.dataset.comparePrice) > Number(thumbnail.dataset.price);
  card.querySelectorAll('.price').forEach((price) => {
    price.classList.toggle('price--on-sale', onSale);
    price.classList.toggle('price--sold-out', !available);
    price.classList.remove('price--no-compare');
    price.dataset.price = thumbnail.dataset.price;
    const regular = price.querySelector('.price__regular .price-item');
    const sale = price.querySelector('.price__sale .price-item--sale');
    const compare = price.querySelector('.price__sale s');
    if (regular) regular.textContent = thumbnail.dataset.money;
    if (sale) sale.textContent = thumbnail.dataset.money;
    if (compare) compare.textContent = onSale ? thumbnail.dataset.compareMoney : '';
  });
  const status = card.querySelector('[data-design-status]');
  if (status) status.textContent = thumbnail.dataset.variantTitle;
});
